import tt from '@/i18n/utils/translateText';
import isTenantVerified from '@/domains/isTenantVerified';
import { useTenantsStore } from '@/stores/tenants';

export const getDescriptionForRestrictionLayout = (): string => {
  const tenantsStore = useTenantsStore();

  const hasLicenseRole = !!tenantsStore.currentTenantDetails?.licenseRole;

  // для НЕверифицированного тенанта
  if (!isTenantVerified()) {
    // есть уже выбран тип организации
    if (hasLicenseRole) {
      return tt('billing.restrictionLayout.verificationDescription');
    }
    return tt('tenant.licenseNoticeGlobal.text');
  }

  // для верифицированного тенанта
  return !hasLicenseRole ? tt('tenant.licenseNoticeGlobal.text') : '';
};
